import Checkbox from '@mui/material/Checkbox';
import React from 'react';
import PropTypes from 'prop-types';

const OrderCheckBox = (props) => {
  const handleChange = (event, isChecked) => {
    let updatedOrders;
    if (props.setConfirmation) {
      props.setConfirmation(isChecked);
    } else {
      updatedOrders = props.orders.map((element, idx) => {
        return idx === props.index
          ? {
              ...element,
              checked: isChecked,
            }
          : element;
      });
      // Keeping checbox for selecting/deselecting all orders in sync
      updatedOrders?.filter((order) => order.checked).length ===
      props.orders.length
        ? props.setAllSelected(true)
        : props.setAllSelected(false);
      props.setOrders(updatedOrders);
    }
  };

  return (
    <Checkbox
      checked={props.value}
      className={'customized-checkbox'}
      sx={{
        color: '#8493AE',
        '&.Mui-checked': {
          color: '#054E8B',
        },
        '&.MuiButtonBase-root': {
          padding: '0px',
          verticalAlign: 'middle',
        },
      }}
      onChange={handleChange}
    />
  );
};

OrderCheckBox.propTypes = {
  setConfirmation: PropTypes.func,
  orders: PropTypes.array,
  value: PropTypes.bool,
  setOrders: PropTypes.func,
  index: PropTypes.number,
  setAllSelected: PropTypes.func,
};
export default OrderCheckBox;
